import classes from '@/containers/pages/commonSettings/tabs/StoragePage/styles.module.css';
import { Button } from '@mantine/core';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { IUsePopUpUI } from '@components/UI/PopUp';
import { storageConfigurationApiArea } from '@/services/api/storageConfigurationApiArea';

interface DeleteDialogProps extends IUsePopUpUI {
  storageId: number;
  onSuccess?: () => void;
}

const ClearStorageDataDialog = (props: DeleteDialogProps) => {
  const { t } = useTranslation();
  const { handleClosePopUp, storageId, onSuccess } = props;
  const [isLoading, setIsLoading] = useState(false);

  const handleDelete = async () => {
    try {
      setIsLoading(true);
      await storageConfigurationApiArea().DeleteStorageConfiguration({ id: storageId });

      if (onSuccess) {
        await onSuccess();
      }
      handleClosePopUp();
    } catch (error) {
      // Игнорируем ошибку
    } finally {
      setIsLoading(false);
    }
  };

  const handleCancel = () => {
    handleClosePopUp();
  };

  return (
    <div className={classes.removeDialog}>
      <div className={classes.removeDialogQuestion}>
        Файлы подразделений, не имеющих доступа к текущему хранилищу, будут удалены без возможности
        восстановления.
      </div>
      <div className={classes.removeDialogActions}>
        <Button
          fullWidth={true}
          color="gray"
          variant="light"
          onClick={handleCancel}
          disabled={isLoading}
        >
          {t('storagePage.deleteDialog.cancelButton')}
        </Button>
        <Button
          fullWidth={true}
          color="red"
          variant="light"
          onClick={handleDelete}
          loading={isLoading}
          disabled={isLoading}
        >
          {t('storagePage.deleteDialog.deleteButton')}
        </Button>
      </div>
    </div>
  );
};

export default ClearStorageDataDialog;
